import { hubAmplifySignOut } from '@/utils/auth/clearMfaSessionSatisfaction';
import { setCallback } from '@/utils/auth/callbacks';
import {
  SESSION_LIMIT_COOKIE_NAME,
  removeSessionTimer,
  startSessionTimer,
} from '@/utils/auth/sessionLimitCookie';
import { getUTCEpochTime } from '@/utils/datetime';
import type { NextRouter } from 'next/router';
import { getCookie } from 'cookies-next';

export const DEFAULT_SESSION_LIMIT_VALUE = 720;
export const NO_SESSION_LIMIT_VALUE = -1;

export { removeSessionTimer, startSessionTimer };

interface CheckSessionLimitDeps {
  router?: Pick<NextRouter, 'push' | 'asPath'>;
  updateSnack?: (alert: { severity: string; message: string }) => void;
}

export function checkSessionLimit(
  timeout = DEFAULT_SESSION_LIMIT_VALUE,
  { router, updateSnack }: CheckSessionLimitDeps
): void {
  const sessionTimeout = getCookie(SESSION_LIMIT_COOKIE_NAME);
  if (!sessionTimeout || timeout === NO_SESSION_LIMIT_VALUE) {
    return;
  }
  const currTime = getUTCEpochTime();
  const difference = currTime - Number(sessionTimeout);
  if (difference > timeout * 60 * 1000) {
    hubAmplifySignOut({ reason: 'session-limit' }).then(() => {
      setCallback(router?.asPath);
      router?.push('/login');
      updateSnack?.({
        severity: 'warning',
        message: 'Session expired. Please log in again.',
      });
    });
  }
}
